module.exports = __webpack_public_path__ + "static/media/amex.83e2b6d4.svg";